module.exports = __webpack_public_path__ + "img/pack-premium.37a78f0a.png";